import { resolvePublicAssetUrl } from '@/utils/resolvePublicAssetUrl'
import { INSTANCE_PROFILE, type InstanceProfile } from '@/config/instanceProfile'

/** Logos compactas — só com menu recolhido (Novo CRM/Logo/) */
export const LOGO_AGRADA_PRETA = '/logo-agrada-preta.png'
export const LOGO_AGRADA_BRANCA = '/logo-agrada-branca.ico'

/** Logos padrão do sidebar expandido (Agrada) */
export const LOGO_SIDEBAR_LIGHT = '/logo-sidebar-light.png'
export const LOGO_SIDEBAR_DARK = '/logo-sidebar.png'

/** Rocket Search — wordmark: escrita branca (escuro) / escrita preta (claro) */
export const LOGO_ROCKET_DARK = '/logo-rocket-dark.png'
export const LOGO_ROCKET_LIGHT = '/logo-rocket-light.svg'

/** Rocket Search — só ícone do foguete (menu recolhido), de Logo/svgrocket */
export const LOGO_ROCKET_ICON_DARK = '/logo-rocket-icon-dark.svg'
export const LOGO_ROCKET_ICON_LIGHT = '/logo-rocket-icon-light.svg'

export function getCollapsedSidebarLogo(
  mode: 'dark' | 'light',
  profile: InstanceProfile = INSTANCE_PROFILE,
): string {
  if (profile === 'rocket') {
    return mode === 'dark' ? LOGO_ROCKET_ICON_DARK : LOGO_ROCKET_ICON_LIGHT
  }
  return mode === 'dark' ? LOGO_AGRADA_BRANCA : LOGO_AGRADA_PRETA
}

export function getExpandedSidebarLogo(
  mode: 'dark' | 'light',
  themeUrls: { logoUrlDark?: string | null; logoUrlLight?: string | null; logoUrl?: string | null },
  profile: InstanceProfile = INSTANCE_PROFILE,
): string {
  // Rocket e Agrada: usa o que está em Aparência → Identidade; fallback do build.
  let path: string
  if (mode === 'dark') {
    path =
      themeUrls.logoUrlDark ||
      themeUrls.logoUrl ||
      (profile === 'rocket' ? LOGO_ROCKET_DARK : LOGO_SIDEBAR_DARK)
  } else {
    path =
      themeUrls.logoUrlLight ||
      themeUrls.logoUrl ||
      (profile === 'rocket' ? LOGO_ROCKET_LIGHT : LOGO_SIDEBAR_LIGHT)
  }
  return resolvePublicAssetUrl(path)
}

export function getExpandedSidebarLogoFallback(
  mode: 'dark' | 'light',
  profile: InstanceProfile = INSTANCE_PROFILE,
): string {
  if (profile === 'rocket') {
    return mode === 'dark' ? LOGO_ROCKET_DARK : LOGO_ROCKET_LIGHT
  }
  return mode === 'dark' ? LOGO_SIDEBAR_DARK : LOGO_SIDEBAR_LIGHT
}
